import { render, staticRenderFns } from "./odHomepage.vue?vue&type=template&id=773f64af&scoped=true"
import script from "./odHomepage.vue?vue&type=script&lang=ts"
export * from "./odHomepage.vue?vue&type=script&lang=ts"
import style0 from "./odHomepage.vue?vue&type=style&index=0&id=773f64af&prod&lang=less&scoped=true"
import style1 from "./odHomepage.vue?vue&type=style&index=1&id=773f64af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f64af",
  null
  
)

export default component.exports